import WrapperFormulaNode from "./WrapperFormulaNode.js";

/**
 * `previousPeriodFormulaNode` is a concrete implementation of `abstractFormulaNode`
 * representing a previous period node.
 *
 * @param {number} spec.numPeriods - number of periods to go back in time in terms of periods of same type
 */

/**
 * TODO: write documentation
 */
export default class PreviousPeriodFormulaNode extends WrapperFormulaNode {
	constructor({ numPeriods } = {}) {
		super(...arguments);
		this._numPeriods = numPeriods;
	}

	getNumPeriods() {
		return this._numPeriods;
	}

	accept(visitor, additionalInformation) {
		return visitor.visitPreviousPeriodNode(this, additionalInformation);
	}

	_serializedProperties() {
		const properties = super._serializedProperties();

		properties.numPeriods = this._numPeriods;

		return properties;
	}

	static getType() {
		return "PreviousPeriodNode";
	}
}
